import * as yup from 'yup';
import moment from 'moment';
import * as FORM_TYPES from '../constants/forms.constants';
import { SCENARIOS } from '../plannerConfig';

// Fields
export const SCENARIO_FIELDS = {
  NAME: 'name',
  COMMENT: 'comment',
  COPY_FROM: 'copyFrom',
  DATERANGE: 'dateRange',
};

// Form Definition
const definition = () => [
  {
    label: 'Scenario Name',
    key: SCENARIO_FIELDS.NAME,
    component: FORM_TYPES.INPUT,
    validation: yup.string().min(2).required(),
  },

  {
    label: 'Comment',
    key: SCENARIO_FIELDS.COMMENT,
    component: FORM_TYPES.INPUT,
    validation: yup.string(),
  },

  {
    label: 'Copy Data From',
    key: SCENARIO_FIELDS.COPY_FROM,
    component: FORM_TYPES.SCENARIO_PICKER,
    validation: yup.string(),
    lookupData: [SCENARIOS],
  },

  {
    label: 'Date Range',
    key: SCENARIO_FIELDS.DATERANGE,
    component: FORM_TYPES.WEEK_PICKER,
    validation: yup.object(),
  },
];

const momentObj = moment();
const format = 'YYYY-MM-DD';

// Initial Form Values

export const initialDateObject = {
  moment: momentObj,
  start: momentObj.startOf('isoWeek').format(format),
  end: momentObj.endOf('isoWeek').format(format),
};


const initialValues = {
  [SCENARIO_FIELDS.NAME]: '',
  [SCENARIO_FIELDS.COMMENT]: '',
  [SCENARIO_FIELDS.COPY_FROM]: 0,
  [SCENARIO_FIELDS.DATERANGE]: initialDateObject,
};

// Validation
const schema = () => yup.object().shape({
  ...definition().reduce((acc, curr) => ({ ...acc, [curr.key]: curr.validation }), {}),
});

const scenarioCreate = () => (
  {
    definition: definition(),
    initialValues,
    schema: schema(),
  }
);

export default scenarioCreate;
